import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewChild, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { DialogLayoutComponent } from "@obg/mat.ui.core";

import { LpcseTimeOffConfirmContainerData } from "./lpcse-time-off-confirm.model";

@Component({
	selector: "obg-m-lpcse-time-off-confirm-container",
	templateUrl: "./lpcse-time-off-confirm.container.html",
	styleUrls: ["./lpcse-time-off-confirm.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LpcseTimeOffConfirmContainer {
	@HostBinding("class.obg-m-lpcse-time-off-confirm-container")
	@ViewChild("dialog", { static: true })
	dialogLayout: DialogLayoutComponent | undefined;

	constructor(@Inject(MAT_DIALOG_DATA) public data: LpcseTimeOffConfirmContainerData | undefined) {}

	confirm() {
		this.data?.confirmHandler(this.data.timeout);
	}

	closeDialog() {
		if (this.dialogLayout) {
			this.dialogLayout.close();
		}
	}
}
